<template>
  <v-container>

    <v-snackbar v-model="snackbar.show" :timeout="3000" :color="snackbar.color" text top right>
      {{ snackbar.text }}
    </v-snackbar>

    <v-card elevation="4" class="pa-4">
      <v-card-title class="text-h5 font-weight-bold">
        <v-icon left color="orange darken-2">mdi-cart</v-icon>
        Mi Carrito
      </v-card-title>

      <!-- CARRITO VACÍO -->
      <v-card-text v-if="carrito.length === 0" class="text-center py-10">
        <v-icon size="80" color="grey lighten-1">mdi-cart-off</v-icon>
        <p class="mt-4 grey--text" style="font-size: 16px;">Tu carrito está vacío</p>
        <v-btn outlined color="primary" class="ma-2" @click="irATienda">
          <v-icon left>mdi-store</v-icon>
          Ir a la tienda
        </v-btn>
        <v-btn outlined color="blue darken-4" class="ma-2" @click="$router.push('/data_user')">
          <v-icon left>mdi-account-cog</v-icon>
          Mi Cuenta
        </v-btn>
        <v-btn outlined color="teal" class="ma-2" @click="$router.push('/mis-pedidos')">
          <v-icon left>mdi-clipboard-list</v-icon>
          Ver Mis Pedidos
        </v-btn>
      </v-card-text>

      <!-- TABLA DE ITEMS -->
      <v-card-text v-else>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Imagen</th>
                <th>Descripción</th>
                <th>Precio</th>
                <th>Cantidad</th>
                <th>Subtotal</th>
                <th>Quitar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in carrito" :key="i">
                <td style="width: 60px;">
                  <v-img
                    v-if="!imagenError[item.producto.id]"
                    :src="serverUrl + 'api/productos/get_img_unico_producto/' + item.producto.id + '/' + item.producto.link_photo"
                    width="50" height="50"
                    contain
                    @error="onImageError(item.producto.id)"
                  ></v-img>
                  <v-icon v-else size="50" color="grey lighten-1">mdi-image-off</v-icon>
                </td>
                <td>{{ item.producto.descripcion }}</td>
                <td>{{ formatearPrecio(item.producto.pvu) }}</td>
                <td style="width: 100px;">
                  <v-text-field
                    v-model.number="item.cantidad"
                    type="number"
                    min="1"
                    :max="item.producto.cantidad_total"
                    dense hide-details outlined
                    style="max-width: 80px;"
                    @input="validarCantidad(item)"
                  ></v-text-field>
                </td>
                <td class="font-weight-bold">{{ formatearPrecio(item.cantidad * item.producto.pvu) }}</td>
                <td>
                  <v-btn icon small color="red" @click="quitarItem(item.producto.id)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <!-- TOTAL -->
        <v-divider class="my-4"></v-divider>
        <div class="d-flex justify-end align-center">
          <span style="font-size: 20px; font-weight: 700; color: #8B0000;">
            Monto Total: {{ formatearPrecio(totalCarrito) }}
          </span>
        </div>

        <!-- BOTONES -->
        <v-row class="mt-4">
          <v-col cols="12" sm="4">
            <v-btn block outlined color="primary" @click="irATienda">
              <v-icon left>mdi-store</v-icon>
              Seguir comprando
            </v-btn>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn block outlined color="red" @click="vaciarCarrito">
              <v-icon left>mdi-cart-remove</v-icon>
              Vaciar carrito
            </v-btn>
          </v-col>
          <v-col cols="12" sm="4">
            <v-btn
              block
              color="success"
              :disabled="carrito.length === 0 || cargando"
              :loading="cargando"
              @click="confirmarPedido"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Confirmar Pedido
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DIÁLOGO DE CONFIRMACIÓN PARA VACIAR CARRITO -->
    <v-dialog v-model="dialogVaciar" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="red">mdi-alert-circle</v-icon>
          Confirmar acción
        </v-card-title>
        <v-card-text>
          ¿Desea vaciar el carrito? Se eliminarán todos los productos.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelarVaciar">Cancelar</v-btn>
          <v-btn color="red" text @click="confirmarVaciar">Vaciar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoginCarrito v-model="dialogLogin" @cambiar-a-registro="irARegistro" @login-exitoso="onLoginExitoso" />
    <RegisterCarrito v-model="dialogRegister" @cambiar-a-login="irALogin" @registro-exitoso="onRegistroExitoso" />
  </v-container>
</template>

<script>
import pedidoService from '@/services/pedidoService';
import { http } from '@/services/config';
import { formatearPrecio } from '@/utils/formatearPrecio';
import LoginCarrito from '@/components/tienda/carrito/LoginCarrito';
import RegisterCarrito from '@/components/tienda/carrito/RegisterCarrito';

export default {
  name: 'CarritoCompra',
  components: { LoginCarrito, RegisterCarrito },

  data() {
    return {
      serverUrl: http.defaults.baseURL,
      snackbar: { show: false, text: '', color: '' },
      dialogLogin: false,
      dialogRegister: false,
      dialogVaciar: false,
      cargando: false,
      imagenError: {}
    };
  },

  computed: {
    carrito() {
      return this.$store.state.carrito;
    },
    totalCarrito() {
      return this.$store.getters.totalCarrito;
    }
  },

  methods: {
    formatearPrecio,

    onImageError(productoId) {
      this.$set(this.imagenError, productoId, true);
    },

    validarCantidad(item) {
      const maxStock = parseInt(item.producto.cantidad_total, 10);

      // Handle non-numeric, empty, null, undefined, NaN, or decimal values
      let cantidad = item.cantidad;
      if (cantidad === '' || cantidad === null || cantidad === undefined || isNaN(Number(cantidad))) {
        item.cantidad = 1;
      } else {
        // Floor decimals to integer
        cantidad = Math.floor(Number(cantidad));

        if (cantidad > maxStock) {
          item.cantidad = maxStock;
          this.mostrarMensaje('Cantidad máxima disponible: ' + maxStock, 'warning');
        } else if (cantidad < 1) {
          item.cantidad = 1;
        } else {
          item.cantidad = cantidad;
        }
      }

      this.$store.commit('actualizarCantidadCarrito', {
        productoId: item.producto.id,
        cantidad: item.cantidad
      });
    },

    quitarItem(productoId) {
      const item = this.carrito.find(i => i.producto.id === productoId);
      const nombre = item ? item.producto.descripcion : 'Producto';
      this.$store.commit('quitarDelCarrito', productoId);
      this.mostrarMensaje(`"${nombre}" fue eliminado del carrito`, 'info');
    },

    vaciarCarrito() {
      this.dialogVaciar = true;
    },

    confirmarVaciar() {
      this.$store.commit('vaciarCarrito');
      this.dialogVaciar = false;
      this.mostrarMensaje('El carrito fue vaciado', 'info');
    },

    cancelarVaciar() {
      this.dialogVaciar = false;
    },

    confirmarPedido() {
      if (this.carrito.length === 0) return;

      // Verificar si hay token (usuario logueado)
      const token = localStorage.getItem('token');
      if (!token) {
        this.dialogLogin = true;
        return;
      }

      this.enviarPedido();
    },

    async enviarPedido() {
      this.cargando = true;

      const payload = {
        detalles: this.carrito.map(item => ({
          producto_id: item.producto.id,
          cantidad: item.cantidad,
          precio_pedido: parseFloat(item.producto.pvu)
        }))
      };

      try {
        await pedidoService.save(payload);
        this.$store.commit('vaciarCarrito');
        this.mostrarMensaje('Pedido confirmado correctamente', 'success');
      } catch (error) {
        if (error.code === 'ECONNABORTED') {
          // Timeout (30s exceeded)
          this.mostrarMensaje('Tiempo de espera agotado. Intente nuevamente.', 'error');
        } else if (error.response && error.response.status === 401) {
          // Token expirado o inválido
          this.dialogLogin = true;
        } else {
          const msg = error.response?.data?.message || 'Error al confirmar el pedido';
          this.mostrarMensaje(msg, 'error');
        }
      } finally {
        this.cargando = false;
      }
    },

    irATienda() {
      this.$router.push('/store/all');
    },

    irARegistro() {
      this.dialogLogin = false;
      this.$nextTick(() => { this.dialogRegister = true; });
    },

    irALogin() {
      this.dialogRegister = false;
      this.$nextTick(() => { this.dialogLogin = true; });
    },

    onLoginExitoso() {
      this.mostrarMensaje('Sesión iniciada correctamente. Ya puede confirmar su pedido.', 'success');
    },

    onRegistroExitoso() {
      this.mostrarMensaje('Cuenta creada correctamente. Ya puede confirmar su pedido.', 'success');
    },

    mostrarMensaje(text, color) {
      this.snackbar = { show: true, text, color };
    }
  }
};
</script>
